import { filter, head, includes, size } from "lodash";
import { Role } from "@linkfluence/models/role";

export enum BannerType {
  Info = "info",
  Warn = "warn",
}

export type Banner = {
  id: number;
  message: string;
  roles: Role[];
  type: BannerType;
};

export function getVisibleBannerFromRole(
  banners: Banner[],
  role: Role
): Banner {
  return head(getFilteredBannersFromRole(banners, role));
}

function getFilteredBannersFromRole(banners: Banner[], role: Role): Banner[] {
  return filter(banners, hasRole(role));
}

function hasRole(role: Role) {
  return (banner: Banner): boolean => {
    return !size(banner.roles) || includes(banner.roles, role);
  };
}
